// extracted by mini-css-extract-plugin
module.exports = {"button":"hJw-4mMan19kYCBODSMzG","icon":"_1-U8sJLk45Ha9pCUK0jMKm"};